import { render, staticRenderFns } from "./DemoBoard.vue?vue&type=template&id=ccde0962&"
import script from "./DemoBoard.vue?vue&type=script&lang=js&"
export * from "./DemoBoard.vue?vue&type=script&lang=js&"
import style0 from "./DemoBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports